import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle } from "react-native-svg";

export const IconReduceMotion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconReduceMotion"><Circle cx="15" cy="12" r="7.5" stroke="currentColor"/><Circle cx="9" cy="12" r="7.5" stroke="currentColor" strokeLinecap="round" strokeDasharray="0.01 2.5"/></CentralIconBase>;
});

export default IconReduceMotion;
